import { z } from "zod";

const PermissionSchema = z.object({
    id: z.number(),
    name: z.string(),
    group: z.string().nullable(),
    display_name: z.string().nullable(),
});

const DataSchema = z.record(z.array(PermissionSchema));

export const PermissionsResponse = z.object({
    code: z.number(),
    message: z.string(),
    success: z.boolean(),
    data: DataSchema,
});

export type PermissionsResponse = z.infer<typeof PermissionsResponse>;
export type Permission = z.infer<typeof PermissionSchema>;